module.exports = __webpack_public_path__ + "img/mobile-icon.878e1e4d.jpg";